module.exports = flarum.core.compat['helpers/userOnline'];